import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../../mfe/MfeLoader";
import { getPoliciesHostConfig } from "../../config/policiesHostConfig";
import { useHostNavigate } from "../../hooks/useHostNavigate";
import { usePermissionState } from "../../contexts/PermissionStateContext";

export const Route = createFileRoute("/policies/")({
  component: PoliciesPage,
});

function PoliciesPage() {
  const onNavigate = useHostNavigate();
  const permissionState = usePermissionState();
  return (
    <MfeLoader
      name="policies"
      props={{ hostConfig: getPoliciesHostConfig(onNavigate, permissionState) }}
    />
  );
}
